import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { RealTimeToast } from './components/RealTimeToast'
import { Dashboard } from './pages/Dashboard'
import { Wallets } from './pages/Wallets'
import { WalletDetail } from './pages/WalletDetail'
import { Markets } from './pages/Markets'
import { MarketDetail } from './pages/MarketDetail'
import { Bots } from './pages/Bots'
import { BotDetail } from './pages/BotDetail'
import { Alerts } from './pages/Alerts'
import { Settings } from './pages/Settings'
import { Login } from './pages/Login'
import { Register } from './pages/Register'
import Analytics from './pages/Analytics'
import AdvancedOrders from './pages/AdvancedOrders'
import Strategies from './pages/Strategies'
import Backtests from './pages/Backtests'
import AIChat from './pages/AIChat'
import { useAuthStore } from './store/authStore'

function App() {
  const { isAuthenticated, isHydrated } = useAuthStore()

  // Wait for auth store to hydrate before rendering
  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Login />} />
      </Routes>
    )
  }

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/wallets" element={<Wallets />} />
          <Route path="/wallets/:id" element={<WalletDetail />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/markets/:id" element={<MarketDetail />} />
          <Route path="/bots" element={<Bots />} />
          <Route path="/bots/:id" element={<BotDetail />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/advanced-orders" element={<AdvancedOrders />} />
          <Route path="/strategies" element={<Strategies />} />
          <Route path="/backtests" element={<Backtests />} />
          <Route path="/ai-chat" element={<AIChat />} />
        </Routes>
      </Layout>
      <RealTimeToast />
    </>
  )
}

export default App
